import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { TimePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import { setOndutyDatasEmpCreateAction } from "../../../../Redux/Slice";
import dayjs from 'dayjs';

function OndutyEmpApply(props) {
    const {
        show,
        setShow,
        editPayload,
        refresh,
        selectedPerformanceId,
        setEditPayload,
        PageIndex,
        status,
        search
    } = props;
    const state = useSelector((state) => state);
    const [value, setValue] = useState();
    const userId = useSelector(
        (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.id
    );
    const [data, setData] = useState({
        for_date: "",
        purpose: "",
        from_time: "",
        to_time: "",
        user_id: state.SideBarFiles.UserIDsemp,
        request_type: "request"

    });
    const [fieldErrors, setFieldErrors] = useState({
        for_date: "",
        purpose: "",
        from_time: "",
        to_time: "",
    });
    const currentDate = dayjs();
    const startOfMonth = currentDate.startOf('month');
    const endOfMonth = currentDate.endOf('month');
  
    const [editMode, setEditMode] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const dispatch = useDispatch();
    const handleError = () => {
        const newFieldErrors = {};
        Object.entries(data).forEach(([key, value]) => {
            if (key === "for_date" && value.length === 0) {
                newFieldErrors[key] = "OnDuty date must not be empty.";
            } else if (key === "from_time" && value.length === 0) {
                newFieldErrors[key] = "From time must not be empty.";
            } else if (key === "to_time" && value.length === 0) {
                newFieldErrors[key] = "To time must not be empty..";
            } else if (key === "purpose" && value.length === 0) {
                newFieldErrors[key] = "purpose must not be empty..";
            } else {
                newFieldErrors[key] = "";
            }
        });
        const hasError = Object.values(newFieldErrors).some((error) => error);
        setFieldErrors(newFieldErrors);
        if (!hasError) {
            const payload = {
                data: data,
                GetFilters: {
                    status: status,
                    search: search,
                    page: PageIndex,
                    page_size: 20,
                    user: data.user_id
                }
            }
            dispatch(setOndutyDatasEmpCreateAction(payload));

            setEditPayload("");
            setData({
                for_date: "",
                purpose: "",
                from_time: "",
                to_time: "",
                user_id: "",
            });
            setFieldErrors({
                for_date: "",
                purpose: "",
                from_time: "",
                to_time: "",
            });
            setShow(false);
        }
    };
    const handleSubmit = () => {
        handleError();

    };
    const handleClose = () => {
        setEditPayload("");
        setShow(false);

        setData({
            for_date: "",
            purpose: "",
            request_type: "",
            from_time: "",
            to_time: "",
        });
        setFieldErrors({
            for_date: "",
            purpose: "",
            from_time: "",
            to_time: "",
        });
    };
    const formatDate = (inputDate) => {
        const date = new Date(inputDate);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const formatDateToHHMM = (dateString) => {
        const date = new Date(dateString);
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
    };
    const handleDate = (inputDate, name) => {
        setFieldErrors((prev) => {
            return {
                ...prev,
                [name]: "",
            };
        });
        const value = formatDate(inputDate);
        setData((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
    };

    // const openMe = () => {
    //     setTimeout(() => {
    //         const rsAnimFade = document.querySelector('.base-Popper-root.MuiPickersPopper-root.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
    //         console.log(rsAnimFade, "sdisad paosd rsAnimFade");
    //         if (rsAnimFade) {
    //             rsAnimFade.style.setProperty('transform', 'translate3d(901px, 356.667px, 0px)', 'important');
    //         }
    //     }, 50); // Delay to allow the element to render
    // };

    const openMe = () => {
        setTimeout(() => {
            const rsAnimFade = document.querySelector('.base-Popper-root.MuiPickersPopper-root.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
            console.log(rsAnimFade, "Popup Element");
    
            if (rsAnimFade) {
                console.log("Popup found, applying styles...");
                rsAnimFade.style.cssText = `
                    transform: translate3d(901px, 298.667px, 0px) !important;
                    visibility: visible !important;
                    opacity: 1 !important;
                    z-index: 9999 !important;
                    position:absolute !important;
                `;
            } else {
                console.log("Popup element not found");
            }
        }, 500); // Delay to allow the popup to render
    };
    
     const openMeToTime  =()=>{
        setTimeout(() => {
            const rsAnimFade = document.querySelector('.base-Popper-root.MuiPickersPopper-root.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
            console.log(rsAnimFade, "sdisad paosd rsAnimFade");
            if (rsAnimFade) {
                rsAnimFade.style.setProperty('transform', 'translate3d(956px, 356.667px, 0px)','important');
            }
        }, 50); // Delay to allow the element to render
     }
    
      

     
       const CloseDateRange = ()=>{
        const rsAnimFade = document.querySelector('.base-Popper-root.MuiPickersPopper-root.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
      

        setTimeout(() => {
            const rsAnimFade = document.querySelector('.base-Popper-root.MuiPickersPopper-root.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
            if (rsAnimFade) {
                rsAnimFade.style.setProperty('display', 'none', 'important');
            }
        }, 50); 

       }

    return (
        <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
            className="modelman"
            size="lg"
            backdrop="static"
        >
            <Modal.Header className="popHead">
                <Modal.Title>
                    {Object.entries(editPayload).length > 0
                        ? "OnDuty"
                        : "OnDuty"}
                </Modal.Title>
                <div className="CloseIcon" onClick={handleClose}>
                    <CloseOutlinedIcon />
                </div>
            </Modal.Header>
            <Modal.Body>
                <>
                    <div className="row">
                        <div className="col">
                            <label className=" p-0" htmlFor="leaveDate">
                                OnDuty Date<span style={{ color: "red" }}>*</span>
                            </label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    style={{ width: "100%" }}
                                    onChange={(e) => {
                                        handleDate(e?.$d, "for_date");
                                    }}
                                    // shouldDisableDate={(date) => {
                                    //     // Get the start and end of the current year
                                    //     const startOfYear = dayjs().startOf('year');
                                    //     const endOfYear = dayjs().endOf('year');
                                    
                                    //     // Disable dates outside the current year
                                    //     return date.isBefore(startOfYear, 'day') || date.isAfter(endOfYear, 'day');
                                    // }}
                                    shouldDisableDate={(date) => {
                                        const today = dayjs();
                            
                                        // Disable all dates except today
                                        return !date.isSame(today, 'day');
                                    }}
                            

                                    // shouldDisableDate={(date) => {
                                    //     // Get today's date and the end of the current year
                                    //     const today = dayjs();
                                    //     const endOfYear = dayjs().endOf('year');
                                    
                                    //     // Disable dates beyond the current year
                                    //     return date.isAfter(endOfYear, 'day');
                                    // }}
                                    
                                />
                                {/* {error.leaveDate && <p>Leave date must be selected.</p>} */}
                                {fieldErrors.for_date && (
                                    <div
                                        className="error"
                                        style={{
                                            color: "red",
                                            height: "20px",
                                            padding: "5px",
                                        }}
                                    >
                                        {fieldErrors.for_date}
                                        <span style={{ color: "red" }}>*</span>
                                    </div>
                                )}
                            </LocalizationProvider>
                        </div>

                        <div className="col OndutyCalanderDesignss">
                            <label className="col-12 p-0" htmlFor="leaveDate" style={{marginLeft:"-17px"}}>
                                OnDuty Time<span style={{ color: "red" }}>*</span>
                            </label>

                            <div className="row">

                                <div className="OndutyCalendarDesgin">
                                    
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            value={data.from_time}
                                            // onChange={(newValue) =>
                                            //     setData((prev) => {
                                            //         return {
                                            //             ...prev,
                                            //             from_time: formatDateToHHMM(newValue.$d),
                                            //         };
                                            //     })
                                            // }

                                            onOpen={() => {
                                                openMe()
                                              }}
                                           onClose={() => {
                                              CloseDateRange()
                                                 }}

                                            onChange={(newValue) => {
                                                setData((prev) => ({
                                                    ...prev,
                                                    from_time: formatDateToHHMM(newValue.$d),
                                                }));
                                                // fieldErrors.from_time = ""; // Reset the error after setting the time
                                            }}
                                            label="From Time"
                                            renderInput={(params) => <TextField {...params} />}
                                        />

                                    </LocalizationProvider>


                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            value={data.to_time}
                                            // onChange={(newValue) =>

                                            //     setData((prev) => {
                                            //         return {
                                            //             ...prev,
                                            //             to_time: formatDateToHHMM(newValue.$d),
                                            //         };
                                            //     })
                                            //     fieldErrors.to_time ="";
                                            // }
                                            onChange={(newValue) => {
                                                setData((prev) => ({
                                                    ...prev,
                                                    to_time: formatDateToHHMM(newValue.$d),
                                                }));
                                                // fieldErrors.to_time = ""; // Reset the error after setting the time
                                            }}
                                            onOpen={() => {
                                                openMeToTime()
                                              }}
                                           onClose={() => {
                                              CloseDateRange()
                                                 }}

                                                 label="To Time"

                                            renderInput={(params) => <TextField {...params} />}
                                        />

                                    </LocalizationProvider>
                                </div>


                                <div style={{ display: "flex" }} >
                                    {fieldErrors.from_time && (
                                        <div
                                            className="error"
                                            style={{
                                                color: "red",
                                                height: "20px",
                                                padding: "5px",
                                            }}
                                        >
                                            {fieldErrors.from_time}
                                            <span style={{ color: "red" }}>*</span>
                                        </div>
                                    )}
                                    {fieldErrors.to_time && (
                                        <div
                                            className="error"
                                            style={{
                                                color: "red",
                                                height: "20px",
                                                padding: "5px",
                                            }}
                                        >
                                            {fieldErrors.to_time}
                                            <span style={{ color: "red" }}>*</span>
                                        </div>
                                    )}
                                </div>


                            </div>
                        </div>
                        <div className="col-12 section1">
                            <label
                                className="mt-4 mb-4"
                                htmlFor="leaveDate"
                                style={{ margin: "0" }}
                            >
                                {" "}
                                Purpose<span style={{ color: "red" }}>*</span>
                            </label>
                            <textarea
                                style={{
                                    width: "100%",
                                    height: "200px",
                                    border: "1px solid lightgrey",
                                    padding: "11px"
                                }}
                                value={data.purpose}
                                onChange={(e) => {
                                    setFieldErrors((prev) => ({
                                        ...prev,
                                        purpose: "",
                                    }));
                                    setData((prev) => ({
                                        ...prev,
                                        purpose: e.target.value,
                                    }));
                                }}
                            />
                            {fieldErrors.purpose && (
                                <div
                                    className="error"
                                    style={{
                                        color: "red",
                                        height: "20px",
                                        padding: "5px",
                                    }}
                                >
                                    {fieldErrors.purpose}
                                    <span style={{ color: "red" }}>*</span>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            </Modal.Body>
            <Modal.Footer>
                <div className="RoleButton">


                    <button class="btn CancelBtn" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        class="btn CancelBtn"
                        type="submit"
                        onClick={(e) => {
                            handleSubmit();
                        }}

                    >
                        Submit
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default OndutyEmpApply;